import React from 'react';

function RemovePromoCodeLinkTemplate ({ modelAttributes }) {

	const { SelectedPromoCode } = modelAttributes;

	if (SelectedPromoCode) {

		return <>Remove Coupon Code</>;

	}

	return null;

}

export default RemovePromoCodeLinkTemplate;
